<template>
  <div>
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div slot="title" class="drawer-title">
        <div>
          <span class="name">流程详情-【小叶在2022-06-09发起申请流程11】</span>
          <span class="right">
            审批编号
            <span class="code">SP20220822001</span>
          </span>
        </div>
        <div class="BtnList">
          <el-button type="primary" size="small" @click="agreed">
            同意
          </el-button>
          <el-dropdown size="small" trigger="click" placement="bottom-start">
            <el-button size="small" type="danger">驳回</el-button>

            <el-dropdown-menu slot="dropdown" size="small">
              <el-dropdown-item
                v-for="btn in rejectBtnList"
                :key="btn.operation"
                @click.native="clickMoreOperation(btn)"
              >
                {{ btn.desc }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="" size="small">审批历史</el-button>
          <el-button type="" size="small">流程图</el-button>
          <el-button type="" size="small" @click="print">打印</el-button>
          <el-button type="" size="small" @click="review">审阅</el-button>
          <el-dropdown size="small" trigger="click" placement="bottom-start">
            <el-button size="small">更多</el-button>

            <el-dropdown-menu slot="dropdown" size="small">
              <el-dropdown-item
                v-for="btn in moreBtnList"
                :key="btn.operation"
                @click.native="clickMoreOperation(btn)"
              >
                {{ btn.desc }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="content">
        <el-form label-position="right" label-width="150px">
          <el-form-item label="活动地址:">
            <UnfoldAndPut
              :container="formItemContent"
              :line-clamp="lineClamp"
              :line-height="lineHeight"
              extend-text="展开"
              collamp-text="收起"
              :index="index"
            />
          </el-form-item>
          <el-form-item label="活动计划fdfdfd:">5454</el-form-item>
          <el-form-item label="活动时间:">5454</el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <RejectDialog
      ref="rejectDialog"
      :title="rejectTile"
      @submitForm="submitForm"
    />
    <Transfer ref="transfer" title="转签" @submitForm="submitForm" />
    <TerminateDialog
      ref="terminateDialog"
      :title="dialogTitle"
      @submitForm="submitForm"
    />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import RejectDialog from '@/views/taskManage/components/rejectDialog/rejectToA.vue'
import TerminateDialog from '@/views/taskManage/components/rejectDialog/rejectOrAgreeDialog.vue'
import Transfer from '@/views/taskManage/components/transferDialog.vue'
import UnfoldAndPut from '@/components/unfoldAndPut'
import { Print } from '@/plugins/print'
export default {
  name: 'DetailDrawer',
  components: {
    RejectDialog,
    Transfer,
    TerminateDialog,
    UnfoldAndPut
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      moreBtnList: [
        { operation: 'transfer', desc: '转签' },
        { operation: 'terminate', desc: '超管终止' }
      ],
      rejectBtnList: [
        { operation: 'rejectToA', desc: '驳回到发起人' },
        { operation: 'rejectToB', desc: '驳回到指定节点' },
        { operation: 'rejectToC', desc: '驳回到上一节点' }
      ],
      rejectTile: '',
      formData: null,
      lineClamp: 3,
      lineHeight: 30,
      index: 1,
      dialogTitle: '',
      formItemContent:
        '活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址活动地址'
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    openDrawer() {
      this.drawer = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    clickMoreOperation(btn) {
      this[btn.operation](btn)
    },
    // rejectToA 驳回到发起人
    rejectToA(btn) {
      console.log('驳回到发起人')
      this.rejectTile = btn.desc
      this.$refs.rejectDialog.openDialog()
    },
    // rejectToB 驳回到指定节点
    rejectToB(btn) {
      console.log('驳回到指定节点')
      this.rejectTile = btn.desc
      this.$refs.rejectDialog.openDialog()
    },
    // rejectToC 驳回到上一节点
    rejectToC(btn) {
      console.log('驳回到上一节点')
      this.rejectTile = btn.desc
      this.$refs.rejectDialog.openDialog()
    },
    // 转签
    transfer(btn) {
      console.log('转签')
      this.$refs.transfer.openDialog()
    },
    // 超管终止
    terminate(btn) {
      console.log('超管终止')
      this.dialogTitle = '超管终止'
      this.$refs.terminateDialog.openDialog()
    },
    // 同意
    agreed() {
      console.log('同意')
      this.rejectTile = '同意'
      this.$refs.rejectDialog.openDialog()
    },
    // type 1:超管终止 2：批量通过 3：批量驳回 4：驳回到发起人
    // 5：驳回到指定节点 6：驳回到指定节点 7：同意 8：转签
    submitForm(type, data) {
      console.log('submitForm', 'type', type, 'data', data)
      this.formData = cloneDeep(data)
      console.log('formData', this.formData)
      if (type === 7 || type === 4 || type === 5 || type === 6) {
        this.$refs.rejectDialog.handleClose()
      } else if (type === 1) {
        this.$refs.terminateDialog.handleClose()
      } else {
        this.$refs.transfer.handleClose()
      }
    },
    // 审阅
    review() {
      console.log('审阅')
      this.dialogTitle = '审阅'
      this.$refs.terminateDialog.openDialog()
    },
    // 打印详情表单
    print() {
      Print()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-drawer {
  width: 640px !important;
  background: #f6f8fc;
  padding: 8px;
  .el-drawer__header {
    background: #fff;
    border-radius: 4px;
    padding: 16px;
    align-items: start;
    margin-bottom: 8px;
    .drawer-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      line-height: 24px;
      .right {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 20px;
        .code {
          color: #333;
        }
      }
      .BtnList {
        margin-top: 16px;
        .el-button:not(.el-button--primary):not(.el-button--danger) {
          border-radius: 4px;
          border: 1px solid #2c51ef;
          font-size: 14px;
          font-weight: 400;
          color: #165dff;
        }
        .el-button {
          margin-right: 10px;
        }
      }
    }
  }
  .el-drawer__body {
    background-color: #fff;
    border-radius: 4px;
    padding: 16px;
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        line-height: 30px;
        .el-form-item__label {
          color: #999999;
          line-height: 30px;
        }
        .el-form-item__content {
          color: #333333;
          line-height: 30px;
        }
      }
    }
    .extendBtn {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0;
    }
  }
}
</style>
